import React, { useEffect, useRef } from 'react'
import { useWrappedStorySelector } from 'contexts/Wrapped'
import config from 'constants/config'

function WrappedAudioPlayer() {
  const isMuted = useWrappedStorySelector(state => state.isMuted)
  const isPaused = useWrappedStorySelector(state => state.isPaused)
  const audioRef = useRef<HTMLAudioElement>(null)

  // Start audio playing on mount (muted, so browser allows autoplay)
  useEffect(() => {
    const audio = audioRef.current
    if (!audio) return

    audio.play().catch(() => {})
  }, [])

  // Handle mute state changes - also ensure playing when unmuting
  useEffect(() => {
    const audio = audioRef.current
    if (!audio) return

    audio.muted = isMuted

    // When unmuting, ensure audio is playing (user gesture enables this)
    if (!isMuted && audio.paused) {
      audio.play().catch(() => {})
    }
  }, [isMuted])

  // Handle play/pause state changes
  useEffect(() => {
    const audio = audioRef.current
    if (!audio) return

    if (isPaused) {
      audio.pause()
    } else if (audio.paused) {
      audio.play().catch(() => {})
    }
  }, [isPaused])

  return (
    <audio
      ref={audioRef}
      src={config.WRAPPED_AUDIO_URL}
      loop
      muted={isMuted}
      preload="auto"
      style={{ display: 'none' }}
    />
  )
}

export default WrappedAudioPlayer
